import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { KpiType } from '../../coaching-insight/insight-widget/model/kpi-type.model';
import { I18nService } from '../../i18n/i18n.service';
import { epicDependencies } from '../../store';
import { KpiTypeTranslationMap } from '../constants/kpi-type-translation-map';
import { HeaderRowData } from '../models/header-row-data.model';

export function getHeaderRowData(
    startDate?: Date,
    endDate?: Date,
    type?: KpiType,
): HeaderRowData {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);
    let periodDate: string;

    const i18nService = epicDependencies.injector.get<I18nService>(I18nService);
    const userLocale = i18nService.locale;

    if (startDate == null || endDate == null) {
        periodDate = '';
    } else {
        const startDateFormatted = formatDate(
            startDate,
            'MMMM d, YYYY',
            userLocale,
        );
        const endDateFormatted = formatDate(
            endDate,
            'MMMM d, YYYY',
            userLocale,
        );
        periodDate = `${startDateFormatted} - ${endDateFormatted}`;
    }

    const titleLabel = KpiTypeTranslationMap[type];

    return {
        titleLabel: translateService.instant(titleLabel),
        periodDate,
        hasHeaderIcon: false,
    };
}
